const csharpCourse = {
    id: "csharp-dotnet",
    name: "C#.NET",    
 
    syllabus: [
        {
            number: 1,
            title: "Getting Started",
            topics: [
                "Environment Setup",
                "Basic Syntax",
                "Program Structure"
            ]
        },
        {
            number: 2,
            title: "Data & Variables",
            topics: [
                "Data Types",
                "Variables",
                "Constants",
                "Modifiers"
            ]
        },
        {
            number: 3,
            title: "Core Programming Concepts",
            topics: [
                "Statements",
                "Operators",
                "Using Math Functions",
                "Decision Making (if, switch)",
                "Loops (for, while, foreach, do-while)"
            ]
        },
        {
            number: 4,
            title: "Strings & Date Handling",
            topics: [
                "Strings",
                "Date & Time"
            ]
        },
        {
            number: 5,
            title: "Arrays & Collections",
            topics: [
                "1D Arrays",
                "2D & 3D Arrays",
                "Collections Overview",
                "List",
                "ArrayList",
                "Dictionary",
                "Hashtable"
            ]
        },
        {
            number: 6,
            title: "Methods & Functions",
            topics: [
                "Functions & Arguments",
                "Return Types",
                "in, out, and ref Parameters"
            ]
        },
        {
            number: 7,
            title: "Object-Oriented Programming",
            topics: [
                "Classes & Objects",
                "Constructor & Destructor",
                "Access Levels (public, private, etc.)",
                "Static Class & Static Methods",
                "Stack vs Heap Memory"
            ]
        },
        {
            number: 8,
            title: "Advanced OOP Concepts",
            topics: [
                "Struct & Enum",
                "Abstract Class & Abstract Methods",
                "Interfaces",
                "Inheritance",
                "Multiple Inheritance (via interfaces)",
                "Multilevel Inheritance", 
                {
                    title: "Polymorphism",
                    subTopics: [
                        "Method Overloading",
                        "Method Overriding"
                    ]
                }
            ]
        },
        {
            number: 9,
            title: "Exception Handling & File Operations",
            topics: [
                "Try-Catch-Finally",
                "Exception Classes",
                "Files & Directory Handling"
            ]
        },
        {
            number: 10,
            title: "Application Development",
            topics: [
                "Creating Console Applications",
                "Windows Forms Application",
                "Form Controls",
                "Dialog Boxes",
                "Advanced Forms",
                "Event Handling"
            ]
        },
        {
            number: 11,
            title: "Integration & Libraries",
            topics: [
                "Class Library & DLL Creation",
                "Interacting with Notepad Files",
                "Interacting with Excel Files",
                "Using Visual Studio Features & Shortcuts"
            ]
        }
    ],

    videos: [],

    faq: []
};

export default csharpCourse;